<ng-container *ngIf="infobarItem[mode]">
  <div *ngIf="mode === 'projectstd'">
    <project-infobar-pictures [data]="infobarItem[mode]"></project-infobar-pictures>
  </div>
  <div *ngIf="mode === 'valuationProject'">
    <file-attachment-list mode="valuationProject" [data]="infobarItem[mode]"></file-attachment-list>
  </div>
  <div *ngIf="mode === 'report'">
    <file-attachment-list mode="report" [data]="infobarItem[mode]"></file-attachment-list>
  </div>
  <div *ngIf="mode === 'property'">
    <property-infobar-pictures [data]="infobarItem[mode]"></property-infobar-pictures>
  </div>
</ng-container>
